import { HttpClient, HttpErrorResponse, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BehaviorSubject, empty, Observable, of } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { Role } from '../model/role';
import { User } from '../model/user';
import { ErrorService } from '../services/error.service';

import * as moment from 'moment';
import { environment } from '../../environments/environment';

@Injectable()
export class UserService {

  private asgAdminUrl = environment.asgAdminUrl;
  private asgSecurityUrl = environment.asgSecurityUrl;
  private user: BehaviorSubject<User> = new BehaviorSubject<User>(new User());
  public user$: Observable<User> = this.user.asObservable();

  constructor(
    private http: HttpClient,
    private errSer: ErrorService) {

  }

  public registerUser(data: any) {
    console.log(data);
  }


  DateTimeToDate(date) {
    return new Date(Date.UTC(date.getFullYear(), date.getMonth(), date.getDate()));
  }

  dateTimeToIsoLocalDateString(dateTime) {
    if (dateTime === null) {
      return null;
    }
    let date = this.DateTimeToDate(dateTime);
    let res = date.toISOString().replace("Z", "");
    return res;
  }

  public editUser(data: any) { }

  getUsersList() {
    let url = this.asgAdminUrl + '/asg/admin/users'
    return this.http.get(url).pipe(
      map((data: User[]) => {
        data.map(data => {
          data.validFrom = new Date(moment(data.validFrom).toISOString());
          if (data.validTo) {
            data.validTo = new Date(moment(data.validTo).toISOString());
          }


          data.status = (data.status == 'active') ? 'Active' : (data.status == 'inactive') ? 'In Active' : (data.status == 'delete') ? 'Delete' : 'Active'
        })
        // this.organizations.next(data);
        return data;
      }),
      catchError((error) => {
        // of(error)
        this.errSer.stopLoaderAndShowError(error);
        return empty()
      })
    )
  }


  newUserDetail() {
    this.user.next(new User());
  }
  getUserDetail(id) {
    let url = this.asgAdminUrl + `/asg/admin/users/${id}`;
    return this.http.get(url)
      // return this.http.get('http://localhost:4200/setup/org-user',{params:{id:id}})
      .pipe(
        map((data: any) => {
          // this.user.next(data.data);
          data.validFrom = new Date(moment(data.validFrom).toISOString());
          data.validTo = (data.validTo) ? new Date(moment(data.validTo).toISOString()) : null;
          this.user.next(data);

          return data;
        }),
        catchError((error) => {
          // of(error)
          this.errSer.stopLoaderAndShowError(error);
          return empty()
        })
      )
  }

  adjustForTimezone(date: Date): Date {
    var timeOffsetInMS: number = date.getTimezoneOffset() * 60000;
    date.setTime(date.getTime() - timeOffsetInMS);
    return date
  }

  addUser(user: User) {
    // user.validTo=this.dateTimeToIsoLocalDateString(new Date(user.validTo));
    // user.validFrom=this.dateTimeToIsoLocalDateString(new Date(user.validFrom));
    let url = this.asgAdminUrl + '/asg/admin/users';


    // if (user.validTo) {
    //   user.validTo = this.adjustForTimezone(user.validTo);
    // }
    // user.validFrom = this.adjustForTimezone(user.validFrom);
    // return this.http.post(url, user)
    //   .pipe(
    //     map((data: any) => {

    //       this.user.next(data);
    //       return data
    //     }),
    //     catchError((error) => {
    //       // of(error)
    //       this.errSer.stopLoaderAndShowError(error);
    //       return empty()
    //     })
    //   )
    return this.http.post(url,user)
    .toPromise()
    .then((response: any) => response as any)
    .catch();
  }

  deleteUser(id, data) {

    return this.http.put<any>(this.asgAdminUrl + '/asg/admin/users/' + id + '/deactivate', data)
      .pipe(map(dataRes => {
        return dataRes;
      }),
        catchError((error) => {
          // of(error)
          this.errSer.stopLoaderAndShowError(error);
          return empty()
        })
      )


  }

  updateUser(id, user: User) {
    // user.validTo=this.dateTimeToIsoLocalDateString(new Date(user.validTo));
    // user.validFrom=this.dateTimeToIsoLocalDateString(new Date(user.validFrom));
    let url = this.asgAdminUrl + `/asg/admin/users/${id}`;
    user.userId = id;
    user.validTo = this.adjustForTimezone(user.validTo);
    user.validFrom = this.adjustForTimezone(user.validFrom);
    return this.http.put(url, user)
      .pipe(
        map((data: User) => {

          return data;
        }),
        catchError((error) => {
          // of(error)
          this.errSer.stopLoaderAndShowError(error);
          return empty()
        })
      )
  }

  getRoleList() {
    let url = this.asgAdminUrl + `/asg/admin/userroles`;

    return this.http.get(url)
      .pipe(
        map((data: Role[]) => {

          return data;
        }),
        catchError((error) => {
          // of(error)
          this.errSer.stopLoaderAndShowError(error);
          return empty()
        })
      )
  }

  getAssociatedDetail(id) {
    return this.http.get<any>(this.asgAdminUrl + '/asg/admin/organizations/' + id + '/associations')
      .pipe(map(dataRes => {

        if (dataRes.users) {

          let dataTemp = dataRes.users;
          dataTemp.map(data => {
            data.validFrom = new Date(moment(data.validFrom).toISOString());
            if (data.validTo) {
              data.validTo = new Date(moment(data.validTo).toISOString());
            }

          })
          return dataTemp;
        }
        else {
          return [];
        }

      }),
        catchError((error) => {
          // of(error)
          this.errSer.stopLoaderAndShowError(error);
          return empty()
        })
      )

  }

  getUserAssociation(id) {
    let url = this.asgAdminUrl + '/asg/admin/users/' + id + '/associations';
    return this.http.get(url)
      .pipe(
        map((data: any) => {
          return data;
        }),
        catchError((error) => {
          // of(error)
          this.errSer.stopLoaderAndShowError(error);
          return empty()
        })
      )
  }


  forgotPassword(email) {
    // user.validTo=this.dateTimeToIsoLocalDateString(new Date(user.validTo));
    // user.validFrom=this.dateTimeToIsoLocalDateString(new Date(user.validFrom));
    let url = this.asgSecurityUrl + '/api/user/forgetPassword/' + email;
    return this.http.put<any>(url, {})
      .pipe(
        map((data: User) => {

          return data;
        }),
        catchError((err: HttpErrorResponse, caught) => {
          console.log(err);

          return of(err);
          // of(err)
        })
      );
  }

  changePassword(id, user, isLoggedIn) {
    let url = "";
    let body = "";
    let options = {};
    if (isLoggedIn == true) {
      // url = this.asgAdminUrl+`/public/v1/users/${id}/changePassword`;
      url = this.asgAdminUrl + `/asg/admin/users/${id}/change-password`;

      body = user;
    }
    else {
      options = {
        headers: new HttpHeaders().set('Content-Type', 'application/json')
      };
      url = this.asgAdminUrl + `/public/v1/api/user/${id}/resetPassword`;

      body = JSON.stringify(user);
    }
    if (isLoggedIn == true) {
      return this.http.put(url, body).toPromise()
        .then((response: any) => response as any)
        .catch();
    }
    else {
      return this.http.put(url, body, options).toPromise()
        .then((response: any) => response as any)
        .catch();
    }
  }
}

